<template>
<div>
    <h1 :class="selected ? 'text-sm pt-2' : 'text-xl pt-0.5 font-bold'"> {{$t('form.dossier_en_attente.validation')}} </h1>
    <div class="p-6 my-4 bg-white border border-gray-200 shadow my-rounded">
        <sav-spinner v-if="loading" :size="10" />
        <template v-if="!loading">
            <template v-if="!isValidated">
                <h1 class="font-bold">{{$t('form.dossier_en_attente.demande_en_attente_de_validation_par_l_enseigne')}}</h1>
                <h3 class="text-sm font-light">{{$t('form.dossier_en_attente.une_notification_vous_sera_envoyee_lorsqu_elle_sera_validee')}}</h3>
            </template>
            <template v-if="isValidated">
                <h1 class="font-bold">
                    <i class="mr-2 text-green-600 fas fa-check-circle"></i>{{$t('form.dossier_en_attente.demande_validee_par_l_enseigne')}}
                </h1>
            </template>
        </template>
    </div>
</div>
</template>

<script>
import FormCardExtension from '@/extends/FormCardExtension'
import apiService from '@/services/api.service'

export default {
    name: 'folder-waiting-request',
    extends: FormCardExtension,

    computed: {
        isValidated() {
            if (this.$formTool.getFormData('request-case') && this.$formTool.getFormData('request-case').etat == 1) {
                return true
            }
            return false
        }
    },

    data() {
        return {
            request: null
        }
    },

    methods: {
        async init() {
            // Check if validated
            if (this.$formTool.getFormData('request-case')) {
                if (this.$formTool.getFormData('request-case').etat == '1') {
                    this.request = JSON.parse(JSON.stringify(this.$formTool.getFormData('request-case')))
                    this.nextBlock = this.getNextRoute()
                    this.emitChange()
                }
                return
            }

            // Check if data
            if (this.$formTool.getFormData(this.$options.name)) {
                this.selected = JSON.parse(JSON.stringify(this.$formTool.getFormData(this.$options.name)))
                this.nextBlock = this.getNextRoute()
                return
            }

            // Check can open card after set-case
            this.removeOpenAfterSetCase()



            let localItems = JSON.parse(localStorage['form-data'])
            for (var localKey in localItems) {
                if (Array.isArray(localItems[localKey])) {
                    var arrayForm = localItems[localKey]
                    for (var arrayKey in arrayForm) {
                        delete localItems[localKey][arrayKey].errors
                        if (arrayForm[arrayKey].type == 'sav-select') {
                            delete localItems[localKey][arrayKey].options
                        }
                    }
                }
            }
            delete localItems.sign
            delete localItems.temp

            // Send request
            if (!this.validated) {
                this.loading = true
                let response = await apiService.post('setaffectapp', {
                    marque: this.$formTool.getFormData('sign').name,
                    purchase_date: this.$formTool.getFormData('purchase-date')[0].value,
                    modele: this.$formTool.getFormData('device')[0].value.id,
                    ean: this.$formTool.getFormData('find-ean-product').ean,
                    file_ticket: this.$formTool.getFormData('casino-ticket-picture')[0].value.id,
                    id_conso: this.$crypto.decrypt(localStorage.getItem('client_id')),
                    file_plaque: this.$formTool.getFormData('nameplate-picture')[0].value.id,
                    form: JSON.stringify(localItems)
                })
                this.end(response.data.posts.post)
                this.loading = false
            }
        },

        end(callbackData) {
            this.$formTool.addFormData(this.$options.name, callbackData)
            if (this.selected) {
                this.$emit('update', this.$options.name)
            }
            this.selected = JSON.parse(JSON.stringify(callbackData))
            this.nextBlock = this.getNextRoute()
        },

        getNextRoute() {
            if (this.isValidated) {
                return this.$formTool.blockData(this.$options.name).next
            }
        },
    },

    mounted() {
        this.init()
    }
}
</script>



// WEBPACK FOOTER //
// src/processes/cards/shop/FolderWaitingRequestCard.vue